<template>
    <div>
      <el-row v-show="showHisFilters">
        <!--查询条件表单-->
        <el-form :model="searchHisForm" ref="searchHisFormRef" size="mini" :inline="true">
         
          <el-col :span="3">
            <el-form-item prop="ruleName">
              <el-input placeholder="费率名称" v-model="searchHisForm.ruleName"  clearable></el-input>
            </el-form-item>
          </el-col>
        
          <el-col :span="1.5">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" :loading="searchHisLoading" @click="submitSearchHisForm">查询
              </el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
  
      <el-table :data="rateHisDataTable" stripe style="width: 100%" ref="rateHisDataTable" border
                v-loading="listHisLoading">
        <af-table-column prop="backupRateId" label="原始费率模型ID"></af-table-column>
        <af-table-column prop="id" label="归档费率模型ID"></af-table-column>
        <af-table-column prop="ruleName" label="归档费率名称"></af-table-column>
        <af-table-column prop="operatorName" label="所属运营商"></af-table-column>
        <af-table-column width="200" label="电费">
          <template slot-scope="scope">
            <div v-if="scope.row.typeCode === 'standard' && scope.row.pileType == 'Q' ">
              <span style="color: #2fff00;" class="span_one">●</span><span
              v-html="' 常规电费 : ' + scope.row.standardElectricityFees + ' 元/kW·h'"></span>
            </div>
            <div v-else-if="scope.row.typeCode === 'times'">
              <span style="color: #ff4d4d;" class="span_one">●</span><span
              v-html=" (scope.row.pileType == 'Q'?' 尖电费 : ':'第一阶段功率') + scope.row.topElectricityFees + (scope.row.pileType == 'Q'?' 元/kW·h':'W')"></span><br/>
              <span style="color:  #ffbc2e " class="span_one">●</span><span
              v-html=" (scope.row.pileType == 'Q'?' 峰电费 : ':'第二阶段功率') + scope.row.summitElectricityFees + (scope.row.pileType == 'Q'?' 元/kW·h':'W')"></span><br/>
              <span style="color: #43c26e" class="span_one">●</span><span
              v-html=" (scope.row.pileType == 'Q'?' 平电费 : ':'第三阶段功率') + scope.row.flatElectricityFees + (scope.row.pileType == 'Q'?' 元/kW·h':'W')"></span><br/>
              <span style="color: #409EFF" class="span_one">●</span><span
              v-html=" (scope.row.pileType == 'Q'?' 谷电费 : ':'第往后阶段功率') + scope.row.valleyElectricityFees + (scope.row.pileType == 'Q'?' 元/kW·h':'W')"></span><br/>
            </div>
          </template>
        </af-table-column>
        <af-table-column width="200" prop="serviceFees" label="服务费">
          <template slot-scope="scope">
            <div v-if="scope.row.typeCode === 'standard'">
              <span style="color: #2fff00;" class="span_one">●</span><span
              v-html="' 常规服务费 : ' + scope.row.standardServiceFees +  (scope.row.pileType == 'Q'?' 元/kW·h':'元/分钟')"></span>
            </div>
            <div v-else-if="scope.row.typeCode === 'times'">
              <span style="color: #ff4d4d;" class="span_one">●</span><span
              v-html="(scope.row.pileType == 'Q'?' 尖服务费 : ':'第一阶段服务费') + scope.row.topServiceFees +  (scope.row.pileType == 'Q'?' 元/kW·h':'元/分钟')"></span><br/>
              <span style="color:  #ffbc2e" class="span_one">●</span><span
              v-html="(scope.row.pileType == 'Q'?' 峰服务费 : ':'第二阶段服务费') + scope.row.summitServiceFees +  (scope.row.pileType == 'Q'?' 元/kW·h':'元/分钟')"></span><br/>
              <span style="color: #43c26e" class="span_one">●</span><span
              v-html="(scope.row.pileType == 'Q'?' 平服务费 : ':'第三阶段服务费') + scope.row.flatServiceFees +  (scope.row.pileType == 'Q'?' 元/kW·h':'元/分钟')"></span><br/>
              <span style="color: #409EFF" class="span_one">●</span><span
              v-html="(scope.row.pileType == 'Q'?' 谷服务费 : ':'往后阶段服务费') + scope.row.valleyServiceFees +  (scope.row.pileType == 'Q'?' 元/kW·h':'元/分钟')"></span><br/>
            </div>
          </template>
        </af-table-column>
        <af-table-column prop="discountRate" label="折扣率"></af-table-column>
        <af-table-column prop="electricLossRate" label="电损比率"></af-table-column>
        <af-table-column label="操作区分">
          <template slot-scope="scope">
            <el-tag v-show="scope.row.operationType === 'U'">编辑</el-tag>
            <el-tag v-show="scope.row.operationType === 'D'" type="danger">删除</el-tag>
          </template>
        </af-table-column>
        <af-table-column prop="updateDate" label="最后更新时间"></af-table-column>
      </el-table>
  
      <!-- 分页组件 -->
      <PaginationHis v-bind:child-msg="pagehisparam" @callFather="changeHisPage"></PaginationHis>
  
    </div>
  </template>
  
  <script>
    import rateApi from "../../api/rateApi";
    import PaginationHis from "../../../../components/Pagination";
  
    export default {
      name: "nowlist",
      data(){
        return{
          showHisFilters: true,
          //历史费率数据 查询
          searchHisLoading: false,
          searchHisForm: {},
          showHisFilters: true,
          rateHisDataTable:[{}],
          listHisLoading:false,
          operatorTree:[],
          pagehisparam: {
            t: {},
            currentPage: 1,
            pageSize: 10,
            total: 0
          },
        }
      },
      props:{
        operatorHisList: ''
      },
      mounted() {
        this.submitSearchHisForm()
      },
      methods:{
        resetSearchHisttoryForm() {
          this.searchHisForm = {}
          this.submitSearchHisForm()
        },
        handleChangeOperator(value) {
          let operatorId = value &&value.length >0 ? value[value.length-1] : ''
          this.searchHisForm.operatorId= operatorId
          this.$refs.cascader.dropDownVisible = false
        },
       // 加载下拉框
        loadSelectItem() {
          rateApi.getOperatorsTree().then((res) => {
            if (res.code === 0) {
              this.operatorTree = res.data
            }
          })
        },
        submitSearchHisForm() {
          this.searchHisLoading = true
          this.listHisLoading = true
          //查询recordType等2的数据
          this.searchHisForm.recordType = 3
          this.pagehisparam.t = this.searchHisForm
          let param = Object.assign({}, this.pagehisparam)
          rateApi.getHisRates(param).then((res) => {
            if (res.code === 0) {
              this.pagehisparam.total = res.data.total
              this.rateHisDataTable = res.data.records
            } else {
  
            }
            this.searchHisLoading = false
            this.listHisLoading = false
          })
        },
        changeHisPage() {
          this.submitSearchHisForm()
        }
      },
      
      created: function () {
      this._data.searchHisForm.stationId = sessionStorage.getItem('stationCode');
    this._data.searchHisForm.operatorId = sessionStorage.getItem('operatorId');
      this.submitSearchHisForm()
    },
    watch: {
    '$store.state.operatorId': {
      handler: function (newVal, oldVal) {
        this._data.searchHisForm.stationId = sessionStorage.getItem('stationCode');
        this._data.searchHisForm.operatorId = sessionStorage.getItem('operatorId');
        this.submitSearchHisForm()
      },
      deep: true
    }
  },
      components:{
        PaginationHis
      }
    }
  </script>
  
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager/nowList.vue